// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-card .md-card-actions[data-v-5feebde5]{border:0;margin-left:20px;margin-right:20px}", ""]);
// Exports
module.exports = exports;
